import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { FormInputProps } from "@/types";
import { InputTooltip } from "@/components/InputTooltip";
import { BRAND, BundleServiceIdHeatPump } from "@/constants/supplyPoint";

export const HeatPumpBrand = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);
  const { serviceAttributes } = useContext(EnumerationsContext);

  const brands = serviceAttributes
    .filter(service => service.attribute === BRAND)
    .filter(service => service.bundleServiceId === BundleServiceIdHeatPump)
    .map(service => ({
      value: service.value,
      label: service.name,
    }));

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesHeatPumpBrand"),
      }}>
      <Select label={t("supplyPoint:heatPumpData.heatPumpBrand")} data={brands} {...props} />
    </InputTooltip>
  );
};
